const EVENTS: {
  name: string;
  icon: string;
  desc: string;
  where: string;
}[] = [
  { name: 'PageView', icon: 'ri-eye-line', desc: 'Chaque page publique vue', where: 'Toutes les pages' },
  { name: 'ViewContent', icon: 'ri-file-search-line', desc: 'Fiche produit consultée', where: 'Catalogue & fiche produit' },
  { name: 'Search', icon: 'ri-search-line', desc: 'Recherche lancée sur la boutique', where: 'Barre de recherche' },
  { name: 'AddToCart', icon: 'ri-shopping-cart-line', desc: 'Produit ajouté au panier', where: 'Fiche produit & catalogue' },
  { name: 'Purchase', icon: 'ri-shopping-bag-line', desc: 'Commande validée', where: 'Checkout' },
  { name: 'Lead', icon: 'ri-user-add-line', desc: 'Formulaire envoyé', where: 'Formulaires & contact' },
];

/** Liste des événements Meta envoyés automatiquement par le site public. */
export default function TrackingEventsCard() {
  return (
    <div className="bg-background-50 border border-background-200/70 rounded-lg p-5">
      <div className="flex items-center justify-between gap-3 mb-1">
        <h3 className="text-sm font-semibold text-foreground-800 flex items-center gap-2">
          <i className="ri-radar-line text-accent-600"></i>
          Événements suivis automatiquement
        </h3>
        <span className="text-[10px] px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-semibold whitespace-nowrap">
          {EVENTS.length} actifs
        </span>
      </div>
      <p className="text-xs text-foreground-500 mb-4">
        Inutile d’ajouter du code : ces événements sont envoyés depuis n’importe quelle page publique
        de votre site.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
        {EVENTS.map((event) => (
          <div key={event.name} className="flex items-start gap-3 p-3 bg-background-100 rounded-lg">
            <div className="w-8 h-8 rounded-lg bg-background-50 flex items-center justify-center flex-shrink-0">
              <i className={`${event.icon} text-sm text-foreground-500`}></i>
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-semibold text-foreground-800">{event.name}</p>
              <p className="text-xs text-foreground-500 leading-snug">{event.desc}</p>
              <p className="text-[10px] text-foreground-400 mt-0.5 truncate">{event.where}</p>
            </div>
            <i className="ri-checkbox-circle-fill text-accent-500 text-sm flex-shrink-0 mt-0.5"></i>
          </div>
        ))}
      </div>
    </div>
  );
}